export default __webpack_public_path__ + "static/sky-e9b1f19524bcbf02402bd0ebb6faba1f.jpg";